import type { Environment } from '../config';
import { environment as ENVIRONMENT_TOKENS } from './tokens';

/**
 * The environment's colour, and the logo's two fills derived from it. **In the
 * theme rather than in the Logo component**, because the login page paints its
 * whole background with it too.
 */

/**
 * The lighter of a pair, derived rather than authored.
 *
 * The brand mark's fills are `#d82036` and `#ec909b`, which is exactly the
 * first mixed halfway with white — `environment.test.ts` pins that, so this is
 * checked against the one pair a designer actually drew.
 */
export const mixWithWhite = (hex: string, amount = 0.5): string => {
  const value = hex.replace('#', '');
  const channels = [0, 2, 4].map((start) => parseInt(value.slice(start, start + 2), 16));

  return `#${channels
    .map((channel) => Math.round(channel + (255 - channel) * amount))
    .map((channel) => channel.toString(16).padStart(2, '0'))
    .join('')}`;
};

/**
 * The colour for an environment: the token map typed against the `Environment`
 * union, so one added to `config.ts` without a colour is a compile error rather
 * than an undefined background.
 */
export const ENVIRONMENT_COLOUR: Record<Environment, string> = ENVIRONMENT_TOKENS;

/**
 * The mark's two fills for an environment. **A tint is a pair, never a single
 * colour** — the mark is two converging streams, so colouring only the front
 * path flattens it into a shape.
 */
export const environmentFills = (name: Environment): { front: string; back: string } => {
  const front = ENVIRONMENT_COLOUR[name];
  return { front, back: mixWithWhite(front) };
};
